import { defa }                      from 'defa-object';
import { AppError, ConnectionError } from 'errors';
import { ObjectHandler }             from 'scripts/defa/application/radio-channel';

/**
 * A basic class for fetching the user profile.
 * Note: Historically this data was pulled from the server before the html was written, so we wouldn't
 *       need to burden the end user with additional http-requests.
 */
export default class UserProfileService {
	
	/**
	 * Fetches the user profile data from the server.
	 * @param tempLang {string} The most likely language the user would want to use.
	 * @returns {Promise<Response | never>}
	 */
	static populateFromAPI( tempLang ) {
		
		let url = `${ defa.vars.apiHost }/users/me/profile`;
		return fetch( url, {
			credentials: 'include',
			headers    : new Headers( {
				'Accept-Language': tempLang
			} ),
		} )
			.catch( err => {
				console.log( `error when fetching ${ url }`, err );
				throw new ConnectionError();
			} )
			.then( r => {
				if ( 200 !== r.status ) {
					return r
						.json()
						.then( json => { throw new AppError( json ); } );
				}
				return r;
			} )
			.then( r => r.json() )
			.then( r => {
				defa.vars.user              = r.vars.user;
				defa.vars.customers         = r.vars.customers;
				defa.vars.mapUsersCustomers = r.vars.mapUsersCustomers;
				defa.vars.units             = r.vars.units;
				defa.vars.phoneNumbers      = r.vars.phoneNumbers;
				
				defa.vars.countries    = r.constants.countries;
				defa.vars.unitTypes    = r.constants.typeUnits;
				defa.vars.vehicleTypes = r.constants.typeVehicles;
				
				defa.vars.logTags         = r.enumConstants.logTags;
				defa.vars.usageTypes      = r.enumConstants.usageTypes;
				defa.vars.invoiceStatuses = r.enumConstants.invoiceStatuses;
				
				defa.vars.languages = r.languages;
				defa.vars.legacyUrl = r.legacyUrl;
				
				ObjectHandler.populateFrom( {
					units       : r.vars.units,
					customers   : r.vars.customers,
					phoneNumbers: r.vars.phoneNumbers
				} );
			} );
	}
	
	/**
	 * Dummy holder for potentially different api-polls for native applications, does glorious nothing.
	 * Note: As of now, the native apps have their own userdata poll, which they inject early into the DOM.
	 * @param tempLang {string} The most likely language the user would want to use.
	 * @returns {Promise<{}>}
	 */
	static populateForApp( tempLang ) {
		// we expect the native application to push their data at the init of the webview instance,
		// which means the language parameter should be set by the app by now if it exists.
		// if not, we fallback to the tempLang. This is done in app/main.js
		
		return Promise.resolve( {} );
	}
}